import { Component, OnInit , Input, Output, EventEmitter,} from '@angular/core';
import { GlobalService } from '../../global.service';
@Component({
  selector: 'app-quantity-device',
  templateUrl: './quantity.component.html',
  styleUrls: ['./quantity.component.sass']
})
export class QuantityComponent implements OnInit {
  @Input() accessory;
  @Input() numMaxItems;
  @Output() quantityAccessories= new EventEmitter<any>();
  @Input() numberAccessories;
  @Input() msjMaxItems:string;
  public maxItems;
  constructor(private global: GlobalService) { }
  ngOnInit(): void {}
  ngOnChanges(){
    if(this.numMaxItems<this.global.maxNumAccessories){
      this.maxItems=this.numMaxItems;
      if(this.numberAccessories>this.maxItems){
        this.numberAccessories=this.maxItems;
      }
      this.quantityAccessories.emit(this.numberAccessories);
    }
    else{
      this.maxItems=this.global.maxNumAccessories;
    }
  }
  numAccessories(value){
    this.numberAccessories=this.numberAccessories+value;
    if(this.numberAccessories>this.maxItems){
      this.numberAccessories=this.maxItems;
      this.global.notif(this.msjMaxItems);
    }
    else if(this.maxItems==0){
      this.numberAccessories=0;
    }
    else if(this.numberAccessories<1){
      this.numberAccessories=1;
    }
    this.quantityAccessories.emit(this.numberAccessories);
  }
}